"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProfileStatusContext = exports.ProfileContext = exports.ProfileActionsContext = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Pc = require("@jobmatchme/amplify-tools/es/api/Pc");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var emptyProfile = {
  active: true,
  revision: 1
};
var ProfileContext = /*#__PURE__*/(0, _react.createContext)(emptyProfile);
exports.ProfileContext = ProfileContext;
var ProfileStatusContext = /*#__PURE__*/(0, _react.createContext)({
  loaded: false
});
exports.ProfileStatusContext = ProfileStatusContext;
var ProfileActionsContext = /*#__PURE__*/(0, _react.createContext)({
  createProfile: function createProfile(profile) {
    return Promise.resolve();
  },
  fetchProfile: function fetchProfile() {
    return Promise.resolve(emptyProfile);
  },
  updateProfile: function updateProfile(changedProperty) {
    return Promise.resolve(emptyProfile);
  },
  updateProfileState: function updateProfileState(status) {
    return Promise.resolve(emptyProfile);
  }
});
exports.ProfileActionsContext = ProfileActionsContext;

var storeForGoogleAnalytics = function storeForGoogleAnalytics(profile) {
  try {
    if (localStorage.getItem('profileGA')) {
      localStorage.removeItem('profileGA'); // Remove old values

      localStorage.setItem('profileGA', JSON.stringify(profile));
    } else {
      localStorage.setItem('profileGA', JSON.stringify(profile));
    }
  } catch (error) {
    return console.error('Error: ', error);
  }
};

var profileFromQuery = function profileFromQuery(profile) {
  return profile || {};
};

var ProfileProvider = function ProfileProvider(_ref) {
  var children = _ref.children,
      _ref$initialProfile = _ref.initialProfile,
      initialProfile = _ref$initialProfile === void 0 ? {} : _ref$initialProfile,
      _ref$initialRevision = _ref.initialRevision,
      initialRevision = _ref$initialRevision === void 0 ? 1 : _ref$initialRevision,
      matchingConfig = _ref.matchingConfig;

  var _useState = (0, _react.useState)((0, _extends2.default)({
    active: true,
    revision: initialRevision
  }, initialProfile)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      profile = _useState2[0],
      setProfile = _useState2[1];

  var _useState3 = (0, _react.useState)({
    loaded: Object.keys(initialProfile).length > 0
  }),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var fetchProfile = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = _Pc.PcApi;
            _context.t1 = "/pcProfileService/rest/profile/get/".concat(matchingConfig.discriminator);
            _context.next = 4;
            return _Pc.PcApi.authHeader();

          case 4:
            _context.t2 = _context.sent;
            _context.t3 = {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: _context.t2
            };
            return _context.abrupt("return", _context.t0.get.call(_context.t0, _context.t1, _context.t3).then(function (rawProfile) {
              return [profileFromQuery(rawProfile)];
            }).then(function (_ref3) {
              var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
                  profile = _ref4[0];

              setProfile(profile);
              storeForGoogleAnalytics(profile);
              setStatus({
                loaded: true
              }); // Re-set abvariant to local storage TODO we need a new backend route for store and fetching
              //if (abVariant) localStorage.setItem('no-ab-test', abVariant)

              // Re-set abvariant to local storage TODO we need a new backend route for store and fetching
              //if (abVariant) localStorage.setItem('no-ab-test', abVariant)
              return profile;
            }).catch(function (error) {
              // No profile yet => is okay
              console.error(error);
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [setProfile, matchingConfig]);
  var createProfile = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(profile) {
      var initial,
          _args2 = arguments;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              initial = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
              return _context2.abrupt("return", _Pc.PcApi.post(initial ? '/pcProfileService/rest/user/createWithProfile' : '/pcProfileService/rest/profile/create', {
                discriminator: profile.discriminator,
                profile: profile
              }, {
                'Content-Type': 'application/json'
              }).then(function (response) {
                storeForGoogleAnalytics(profile);
                setProfile((0, _extends2.default)({}, profile, {
                  active: true,
                  revision: initial ? 1 : response.newRevision
                }));
                setStatus({
                  loaded: true
                });
                return profile;
              }));

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }(), [setProfile]);
  var updateProfile = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(changedProperty) {
      var newProfile;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              newProfile = (0, _extends2.default)({}, profile, changedProperty);
              delete newProfile['__typename'];
              return _context3.abrupt("return", _Pc.PcApi.post('/pcProfileService/rest/user/profile/edit', {
                discriminator: newProfile.discriminator,
                profile: newProfile
              }, {
                'Content-Type': 'application/json'
              }).then(function (response) {
                var updatedProfile = (0, _extends2.default)({}, newProfile, {
                  discriminator: newProfile.discriminator,
                  revision: response.newRevision
                });
                storeForGoogleAnalytics(updatedProfile);
                setProfile(updatedProfile);
                return updatedProfile;
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref6.apply(this, arguments);
    };
  }(), [profile, setProfile]);
  var updateProfileState = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(status) {
      var newProfile, profileStatus, url;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              newProfile = (0, _extends2.default)({}, profile, {
                active: status
              });
              profileStatus = status ? 'activate' : 'deactivate';
              url = "/pcProfileService/rest/profile/".concat(profileStatus, "/").concat(profile.discriminator);
              return _context4.abrupt("return", _Pc.PcApi.post(url, undefined, {
                'Content-Type': 'application/json'
              }).then(function (response) {
                var updatedProfile = (0, _extends2.default)({}, newProfile, {
                  discriminator: profile.discriminator,
                  revision: response.newRevision
                });
                setProfile(updatedProfile);
                storeForGoogleAnalytics(updatedProfile);
                return updatedProfile;
              }).catch(function (e) {
                console.error(e);
              }));

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3) {
      return _ref7.apply(this, arguments);
    };
  }(), [profile]);
  var actions = (0, _react.useMemo)(function () {
    return {
      createProfile: createProfile,
      fetchProfile: fetchProfile,
      updateProfile: updateProfile,
      updateProfileState: updateProfileState
    };
  }, [createProfile, fetchProfile, updateProfile, updateProfileState]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ProfileStatusContext.Provider, {
    value: status,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProfileActionsContext.Provider, {
      value: actions,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ProfileContext.Provider, {
        value: profile,
        children: children
      })
    })
  });
};

var _default = ProfileProvider;
exports.default = _default;